'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var interfaceDatastore = require('interface-datastore');

var keytransform = require('./keytransform.js');

var NamespaceDatastore = /*#__PURE__*/function (_keytransform$KeyTran) {
  _inherits(NamespaceDatastore, _keytransform$KeyTran);

  var _super = _createSuper(NamespaceDatastore);

  function NamespaceDatastore(child, prefix) {
    var _this;

    _classCallCheck(this, NamespaceDatastore);

    _this = _super.call(this, child, {
      convert: function convert(key) {
        return prefix.child(key);
      },
      invert: function invert(key) {
        if (prefix.toString() === '/') {
          return key;
        }

        if (!prefix.isAncestorOf(key)) {
          throw new Error("Expected prefix: (".concat(prefix.toString(), ") in key: ").concat(key.toString()));
        }

        return new interfaceDatastore.Key(key.toString().slice(prefix.toString().length), false);
      }
    });
    _this.prefix = prefix;
    return _this;
  }

  _createClass(NamespaceDatastore, [{
    key: "query",
    value: function query(q, options) {
      if (q.prefix && this.prefix.toString() !== '/') {
        return _get(_getPrototypeOf(NamespaceDatastore.prototype), "query", this).call(this, Object.assign({}, q, {
          prefix: this.prefix.child(new interfaceDatastore.Key(q.prefix)).toString()
        }));
      }

      return _get(_getPrototypeOf(NamespaceDatastore.prototype), "query", this).call(this, q, options);
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(q, options) {
      if (q.prefix && this.prefix.toString() !== '/') {
        return _get(_getPrototypeOf(NamespaceDatastore.prototype), "queryKeys", this).call(this, Object.assign({}, q, {
          prefix: this.prefix.child(new interfaceDatastore.Key(q.prefix)).toString()
        }));
      }

      return _get(_getPrototypeOf(NamespaceDatastore.prototype), "queryKeys", this).call(this, q, options);
    }
  }]);

  return NamespaceDatastore;
}(keytransform.KeyTransformDatastore);

exports.NamespaceDatastore = NamespaceDatastore;